import { useCallback, useEffect, useRef, useState } from "react";

import type { Swiper as SwiperObject } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import Slide from "./Slides/Slide";
import { SlidesContext } from "./Slides/useSlidesContext";

type Props = {
  slides: Slide[];
};

//const autoplayInterval = 6000;
const autoplayInterval = null;

export default function Slides({ slides }: Props) {
  const [slide, setSlide] = useState(slides[0]);

  const swiperRef = useRef<SwiperObject>(null);

  const swipeTo = useCallback(
    (slide: Slide) => {
      if (swiperRef.current) {
        swiperRef.current.slideTo(slides.indexOf(slide));
      }
    },
    [slides]
  );

  const navigate = useCallback(
    (offset: number) => {
      let index = (slides.indexOf(slide) + offset) % slides.length;
      if (index < 0) {
        index += slides.length;
      }
      swipeTo(slides[index]);
    },
    [slides, slide, swipeTo]
  );

  useEffect(() => {
    if (autoplayInterval) {
      const interval = setInterval(() => navigate(1), autoplayInterval);
      return () => clearInterval(interval);
    }
  }, [navigate]);

  return (
    <SlidesContext.Provider
      value={{
        slides: slides,
        swipeTo: swipeTo,
        navigate: navigate
      }}>
      <div className="slides">
        <Swiper
          navigation
          slidesPerView={1}
          onSwiper={(s) => (swiperRef.current = s)}
          onSlideChange={(s) => setSlide(slides[s.activeIndex])}>
          {slides.map((s, index) => (
            <SwiperSlide key={s.id}>
              <Slide slide={s} isFirst={index === 0} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </SlidesContext.Provider>
  );
}
